import React, { useEffect } from 'react'
import MainWrapper from '../MainWrapper'
import Header from '../Header'
import { PickupMonitorWrap } from './index.styled'
import PickupMonitorOrders from './orders'
import ScrollTopButton from '../Elements/buttons/ScrollTopButton'
import { setToggled } from '../../redux/action/system'
import { useDispatch, useSelector } from 'react-redux'
import PickupMonitorModals from './modals'
import { useWindowBreakPoint } from '../../hooks/useWindowBreakPoint'
import { theme } from '../../style/theme'
import PickupMonitorButtons from './buttons'

const PickupMonitor = React.memo(() => {
	const dispatch = useDispatch()
	const toggled = useSelector(store => store.system.toggled)
	const isTablet = useWindowBreakPoint(theme.point820)

	useEffect(() => {
		if (!toggled) {
			dispatch(setToggled(true))
		}
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<Header>
				{!isTablet && <PickupMonitorButtons />}
			</Header>
			<MainWrapper>
				<PickupMonitorWrap>
					{isTablet && <PickupMonitorButtons />}
					<PickupMonitorOrders />
				</PickupMonitorWrap>
				<PickupMonitorModals />
			</MainWrapper>
			<ScrollTopButton />
		</>
	)
})

PickupMonitor.displayName = 'PickupMonitor'
export default PickupMonitor
